import React, {Component} from "react"
import PropTypes from "prop-types"
import {Button, Form, FormField, FormInput} from "elemental"
import _ from "lodash"
import "./Pagination.scss"

export default class ShopPagination extends Component {

  static propTypes = {
    filter:   PropTypes.object,
    onChange: PropTypes.func,
    showNav:  PropTypes.bool,
  }

  render() {
    let {filter} = this.props
    let nPages                             = this.nPages(filter)
    if (nPages <= 1) return null
    return (
      <FormField
        label={`   ${filter.currentPage} von ${nPages} Seiten`}
        htmlFor="form-sort">
        <div className="pagination-wrapper">
          <Form type="inline">

            <Button onClick={() => {this.setPage(1)}}><i className="icon-to-start"/></Button>
            <Button onClick={this.prevPage}><i className="icon-left-open"/></Button>
            <FormInput
              onFocus={this.handleFocus}
              className="page-input"
              name="page-number"
              value={filter.currentPage}
              onChange={this.handlePageSelect}/>
            <Button onClick={this.nextPage} type="primary"><i className="icon-right-open"/></Button>
            <Button onClick={() => {this.setPage(this.nPages(filter))}}><i className="icon-to-end"/></Button>

          </Form>
        </div>
      </FormField>
    )
  }

  handleFocus(event) {
    event.target.select()
  }

  handlePageSelect = e => {
    console.log(`e.target.value`, e.target.value)
    this.setPage(e.target.value)
  }

  setPage(page) {
    console.log(`set page to `, page)
    page = Number(page)
    if (_.isNumber(page) && page > 0 && page <= this.nPages(this.props.filter)) {
      console.log(`page`, page)
      this.props.onChange(page)
    }
  }

  nPages(filter) {
    let nPages = Math.floor(filter.total / (filter.pageSize)) + 1
    return nPages
  }

  nextPage = () => {
    let {filter, onChange} = this.props
    let nPages             = this.nPages(filter)
    let page               = Math.min(nPages, filter.currentPage + 1);
    onChange(page)
  }

  prevPage = () => {
    let {filter, onChange} = this.props
    let page               = Math.max(1, filter.currentPage - 1);
    onChange(page)
  }
}




// WEBPACK FOOTER //
// ./src/components/Pagination/Pagination.js